import { IStore } from 'src/interfaces/store';
import { StoreExtractor } from './types';

export class StoreNameOnlyExtractor implements StoreExtractor<string> {
    extract(store: IStore): string {
        return store.name;
    }

    shouldInclude(store: IStore, makeId?: string): boolean {
        return store.make?._id === makeId;
    }
}
